"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = HoursOfOperationModal;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _IconElement = _interopRequireDefault(require("../IconElement"));

/* eslint-disable jsx-a11y/anchor-is-valid */
function HoursOfOperationModal(props) {
  var iconAs = props.iconAs,
      children = props.children;
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal, {
    className: "hoo-modal",
    dimmer: "inverted",
    trigger: iconAs === 'icon' ? /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "hoo-modal-trigger"
    }, /*#__PURE__*/_react["default"].createElement(_IconElement["default"], {
      iconType: "clock",
      element: /*#__PURE__*/_react["default"].createElement("a", null, "See Hours"),
      iconPosition: "left"
    })) : /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
      icon: "clock",
      secondary: true
    })
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Header, null, /*#__PURE__*/_react["default"].createElement("div", null, "Hours Of Operation")), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Content, null, children));
}